<template>
  <div >
      <div class="whole"  v-if="file.info.type=='pdf'">
        <div style="margin-bottom: 15px; text-align: right" >
          <el-button type="primary" size="small" @click="scaleD">
             放大
           </el-button>
           <el-button type="primary" size="small" @click="scaleX">
             缩小
          </el-button>
          <el-button type="primary" size="small" @click.stop="pdf_previousPage">
             上一页
           </el-button>
           <el-button type="primary" size="small" @click.stop="pdf_nextPage">
           下一页
          </el-button>
          <span>当前第{{file.pdfPage}}页 / 共{{file.pageCount}}页</span>
        </div>
        <div style="overflow: auto; width: 100%; " class="con">
         <pdf
         ref="wrapper"
           :src="file.url"
           :page="file.pdfPage"
           @num-pages="file.pageCount = $event"
           @page-loaded="file.pdfPage = $event"
        ></pdf>
        </div>
      </div>
      <div class="whole" v-if="file.info.type=='html'" >
         <iframe :src="file.url" frameborder="0" style="width:100%;" :height="height"></iframe>
      </div>

  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    data(){
      return{
         num:this.$route.query.num,
         file:{
           scale:100,
           info:[],
           url:'https://upload.zhiyaozhishi.com/admin/file/20201111/5c2a1e240b1782ce9d06ffdbcc275df4.pdf',
           pdfPage : 1,
           pageCount: 0,
         },
      }
    },
    components: {
      pdf
    },
     mounted: function () {
       this.get_info()
       this.change_height()
     },
     methods:{
       scaleD() {
         this.file.scale += 5;
         this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
       },
       //缩小
       scaleX() {
         this.file.scale += -5;
         this.$refs.wrapper.$el.style.width = parseInt(this.file.scale) + "%";
       },
       change_height(){
         let _this=this
         _this.height=window.innerHeight + 'px'
       },
       get_info(){
         let _this=this
         _this.axios.get("/v2/user_resource/get_file_info", {
            params: { file: _this.num,type:'train' },
          })
          .then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.file.info=res.data.data
                if(res.data.data.type=='pdf'){
                  _this.file.url=pdf.createLoadingTask('/v2/user_resource/file_watch?key='+localStorage.authorization)
                }else{
                  _this.file.url='/v2/user_resource/file_watch?key='+localStorage.authorization
                }
              } else {
                _this.$message.error("服务器内部错误");
              }
            } else {
              _this.$message.error("服务器内部错误");
            }
          });
       },
       pdf_previousPage(){
         var p = this.file.pdfPage
         p = p>1?p-1:this.file.pageCount
         this.file.pdfPage = p
       },
       pdf_nextPage(){
         var p = this.file.pdfPage
         p = p<this.file.pageCount?p+1:1
         this.file.pdfPage = p
       },
     },
  }

</script>

<style  scoped>
 /* body{
    background-color: white;
  } */
  .con{
      display: flex;
      justify-content: center;
  }
  .pdf_div{
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/view/index/Task/taskfile/Pdf.vue